export const getProjectOrderNumberName = (params) => {
  const orderNumberParam = params.PROJECT_ORDERNUMBER_NAME;
  const orderNumberName = orderNumberParam && orderNumberParam !== '' ? orderNumberParam : 'Rendelési szám';

  return orderNumberName;
};
